import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './WaitlistModal.css';

const WaitlistModal = () => {
  const [showSuccess, setShowSuccess] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    rentingStatus: ''
  });

  const closeModal = () => {
    document.getElementById('waitlistModal').style.display = 'none';
    document.body.style.overflow = 'auto';
    setShowSuccess(false);
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      rentingStatus: ''
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowSuccess(true);
    
    // Auto-close after 3 seconds
    setTimeout(() => {
      closeModal();
    }, 3000);
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 }
  };

  const successVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <div id="waitlistModal" className="modal">
      <motion.div 
        className="modal-content"
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        transition={{ duration: 0.3 }}
      >
        <span className="close" onClick={closeModal}>&times;</span>
        
        <AnimatePresence mode="wait">
          {!showSuccess ? (
            <motion.div
              key="form"
              initial={{ opacity: 1 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.3 }}
            >
              <h2 className="migra-font">🎉 Join the GusHome Waitlist</h2>
              <p>Be among the first to turn your rent into equity. Get early access when we launch in your city!</p>
              
              <form className="waitlist-form" onSubmit={handleSubmit}>
                <input 
                  type="text" 
                  name="firstName"
                  placeholder="First Name" 
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required 
                />
                <input 
                  type="text" 
                  name="lastName"
                  placeholder="Last Name" 
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required 
                />
                <input 
                  type="email" 
                  name="email"
                  placeholder="Email Address" 
                  value={formData.email}
                  onChange={handleInputChange}
                  required 
                />
                <input 
                  type="tel" 
                  name="phone"
                  placeholder="Phone Number" 
                  value={formData.phone}
                  onChange={handleInputChange}
                  required 
                />
                <select 
                  name="rentingStatus"
                  value={formData.rentingStatus}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Are you currently renting?</option>
                  <option value="yes-nyc">🏙️ Yes, in NYC</option>
                  <option value="yes-boston">🦞 Yes, in Boston</option>
                  <option value="yes-dc">🏛️ Yes, in Washington DC</option>
                  <option value="yes-other">🌆 Yes, in another city</option>
                  <option value="no-investor">💰 No, interested in investing</option>
                </select>
                <button type="submit">🚀 Join the Revolution</button>
              </form>
            </motion.div>
          ) : (
            <motion.div
              key="success"
              className="success-animation"
              variants={successVariants}
              initial="hidden"
              animate="visible"
              transition={{ duration: 0.5 }}
            >
              <div className="success-icon">🎊</div>
              <h3>Welcome to the Future!</h3>
              <p>You're on the waitlist! We'll notify you as soon as GusHome launches in your area.</p>
            </motion.div>
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default WaitlistModal;
